import {I18n} from '@aws-amplify/core';

import {FlexiButton,} from '@flexinet/ui-components';
import {useUserAccount} from "../../../../hooks/useUserAccount.ts";
import {useAccountApplication} from "../../account-applications/hooks/useAccountApplication";
import {AccountApplication} from "../../account-applications/types";
import {AiOutlineClose} from "react-icons/ai";

export const DisableRecordButton = ({
                                        record
                                    }: {
    record: AccountApplication
}) => {

    const {userAccount} = useUserAccount();

    if (!userAccount) {
        throw new Error('User account not found');
    }

    const {deleteRecord} = useAccountApplication(userAccount.id, record.id)

    const onClick = () => {
        deleteRecord();
    };
    return (
        <FlexiButton
            variant={'subtle'}
            leftSection={<AiOutlineClose/>}
            onClick={onClick}
            size={'md'}
        >
            {I18n.get('Disable')}
        </FlexiButton>
    );
};
